import { forwardRef, useState } from 'react';
import { Input, type InputProps } from '@/components/ui';
import { useT } from '@/i18n';

/** A password box with a Show / Hide switch, so a parent on a phone can check what they typed. */
export const PasswordInput = forwardRef<HTMLInputElement, Omit<InputProps, 'type'>>((props, ref) => {
  const t = useT();
  const [shown, setShown] = useState(false);
  return (
    <div className="relative">
      <Input ref={ref} {...props} type={shown ? 'text' : 'password'} className="pr-20" />
      <button
        type="button"
        onClick={() => setShown((s) => !s)}
        aria-pressed={shown}
        className="absolute inset-y-0 right-0 min-w-tap px-4 text-label text-lagoon-600"
      >
        {shown ? t('auth.hidePassword') : t('auth.showPassword')}
      </button>
    </div>
  );
});
PasswordInput.displayName = 'PasswordInput';
